<template>
  <div class="risk-table">
    <el-table
      ref="table"
      :data="list"
      v-loading="loading"
      header-row-class-name="table-header-row"
      border
    >
      <template slot="empty">
        <Empty />
      </template>
      <el-table-column label="Sport" min-width="102px" align="center" class-name="table-font-bold">
        <template slot-scope="scope">
          <div>
            <div v-for="(item,index) in sportList" :key="index">
              <span v-if="scope.row.sportId == Number(item.code)">{{item.value.toUpperCase()}}</span>
            </div>
          </div>
          <span v-if="scope.row.sportId === 0">GENERAL</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="Max Stake Per Day"
        prop="maxDailyStake"
        min-width="145px"
        align="right"
      ></el-table-column>
      <el-table-column
        label="Max Profit Per Day"
        prop="maxDailyWinAmount"
        min-width="145px"
        align="right"
      ></el-table-column>-->
      <el-table-column
        label="Max Stake Factor"
        prop="maxStakeFactor"
        min-width="140px"
        align="center"
      >
        <template slot="header">
          <span>Max Stake Factor</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="The factor of the per bet limit"
            placement="top"
          >
            <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
          </el-tooltip>
        </template>
        <template v-slot="{row}">
          <div v-if="row.maxStakeFactor">
            {{+(row.maxStakeFactor * 100).toFixed(4)}}
            <span>%</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="Max Stake Factor"
        prop="maxStakeFactor"
        min-width="140px"
        align="center"
      >
        <template slot="header">
          <span>Minimum Stake Factor</span>
        </template>
        <template v-slot="{row}">
          <div v-if="row.minStakeFactor">{{row.minStakeFactor}}</div>
        </template>
      </el-table-column>-->
      <el-table-column label="Self-Risk" prop="userCount" min-width="101px">
        <template v-slot="{row}">
          <span>{{row.selfRisk == 1 ? 'ON' : 'OFF'}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Pending Duration" prop="pendingTime" min-width="120px" align="right">
        <template v-slot="{row}">
          <span v-for="(item,index) in pendingList" :key="index">
            <span v-if="row.pendingTime == item.id">{{item.label}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Cashout" min-width="120px" align="right">
        <template slot-scope="scope">
          <div v-if="scope.row.sportId == 0 && scope.row.cashoutSwitch == 0">off</div>
          <div v-else-if="scope.row.sportId == 0 && scope.row.cashoutSwitch >= 1">on</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="Super Limit" min-width="120px" align="right">
        <template slot="header">
          <span>Super Limit</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="Whether exceeded the default limit"
            placement="top"
          >
            <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.sportId == 0 && scope.row.superLimit == true">Yes</div>
          <div v-else-if="scope.row.sportId == 0 && scope.row.superLimit == false">No</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="Single" align="center">
        <el-table-column
          label="Max Stake Per Match"
          prop="singleMaxStakePerMatch"
          min-width="140px"
          align="right"
        ></el-table-column>
        <el-table-column label="Liability" prop="singleMaxLiability" min-width="90px" align="right">
          <template slot="header">
            <span>Liability</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="Max possible win per single bet"
              placement="top"
            >
              <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="Liability Per Match"
          prop="singleMaxLiabilityPerMatch"
          min-width="140px"
          align="right"
        >
          <template slot="header">
            <span>Liability Per Match</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="Max possible win per match"
              placement="top"
            >
              <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="Parlay" align="center">
        <el-table-column label="Liability" min-width="100px" align="right">
          <template slot="header">
            <span>Liability</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="Max possible win per parlay bet"
              placement="top"
            >
              <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.sportId == 0">{{scope.row.multipleMaxLiability}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="Max Stake Per Match" min-width="135px" align="right">
          <template slot-scope="scope">
            <div v-if="scope.row.sportId == 0">{{scope.row.multipleMaxStakePerMatch}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="Max Stake Per Day" min-width="135px" align="right">
          <template slot-scope="scope">
            <div v-if="scope.row.sportId == 0">{{scope.row.multipleMaxDailyStake}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table-column>-->
    </el-table>
  </div>
</template>

<script>
import Empty from "@/components/empty/index";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    isinput: {
      type: Boolean,
      default: false
    },
    sportList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pendingList: [
        {
          id: "5",
          label: "5s"
        },
        {
          id: "10",
          label: "10s"
        },
        {
          id: "15",
          label: "15s"
        },
        {
          id: "30",
          label: "30s"
        },
        {
          id: "60",
          label: "60s"
        },
        {
          id: "-1",
          label: "Manual"
        }
      ],
      selfRiskList: [
        {
          id: 1,
          label: "ON"
        },
        {
          id: 0,
          label: "OFF"
        }
      ]
    };
  },
  methods: {
    CloneListRow(row) {}
  },
  components: {
    Empty
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
